
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { getImages } from "../Const";

const normalize = (str) => str.toLowerCase().replace(/[^a-zA-Z0-9]/g, "");

const AppraisalCustomerTable = ({
    leadAction,
    leadData,
    allLeads,
    leadsLoading,
    visibleData,
    setVisibleData,
    filteredData
}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 20;

    useEffect(() => {
        setIsLoading(true);

        const timer = setTimeout(() => {
            if (!leadsLoading) addAssocLeads();
        }, 500);

        const processedLeads = leadData.map((v) => {
            v.assocLeads = [];
            return v;
        });

        setVisibleData(processedLeads);
        setIsLoading(false);

        return () => {
            clearTimeout(timer);
        };
    }, [leadData.length, allLeads.length, leadsLoading]);

    const addAssocLeads = () => {
        const processedLeads = leadData.map((v) => {
            v.assocLeads =
                "Completed"
                    ? allLeads
                        .filter((lead) => lead.id !== v.id)
                        .filter(
                            (lead) =>
                                (v.email &&
                                    lead.email &&
                                    normalize(lead.email) === normalize(v.email)) ||
                                (v.phone &&
                                    lead.phone &&
                                    normalize(lead.phone) === normalize(v.phone))
                        )
                    : [];
            return v;
        });

        setVisibleData(processedLeads);
    };

    // Pagination calculations
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    const startOffset = currentPage * itemsPerPage;
    const currentItems = filteredData.slice(startOffset, startOffset + itemsPerPage);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        window.scrollTo({ top: 0, behavior: "smooth" }); // scroll up after changing page
    };

    const [hoveredIndex, setHoveredIndex] = useState(null);

    if (isLoading) {
        return (
            <div className="loading-cardrop-box">
                <img
                    className="loading-cardrop-image"
                    src={getImages("loading-cardrop.gif")}
                    alt=""
                />
                <div className="xs-title text-center text-gray text-uppercase font-1em">
                    Appraisals Currently Loading...
                </div>
            </div>
        );
    }

    return (
        <>
            {/* {console.log("currentItems", currentItems)}
            <div>Visible Data:-  {visibleData.length}</div>
            <div>Filtered Data:-  {filteredData.length}</div> */}
            <div className="cqr-table ar-table">
                <table className="w-100">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Customer Name</th>
                            <th>&nbsp;</th>
                            <th>Vehicle Info</th>
                            <th>Location</th>
                            <th className="text-center">
                                <span className="text-nowrap">Created by /</span> <br />Status
                            </th>
                            <th className="text-center">
                                <span className="text-nowrap">COMPLETED /</span> <br />EXPIRATION
                            </th>
                            <th className="text-center">Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentItems.map((item, index) => (
                            <tr key={index}>
                                <td className="cursor-pointer" onClick={() => leadAction(item)}>
                                    {item.lead_id}
                                </td>
                                <td className="cursor-pointer" onClick={() => leadAction(item)}>
                                    {item.full_name}
                                </td>

                                {item?.assocLeads?.length >= 1 ? (
                                    <td>
                                        <div
                                            className={`position-relative popover-block ${hoveredIndex === index ? "hovered" : ""
                                                }`}
                                            onMouseEnter={() => setHoveredIndex(index)}
                                            onMouseLeave={() => setHoveredIndex(null)}
                                        >
                                            <span
                                                className="icon-badge"
                                                style={{
                                                    background: `url(${getImages(
                                                        item.assocLeads.length > 1
                                                            ? "icon-badge-gold.png"
                                                            : "icon-badge-silver.png"
                                                    )})`,
                                                    color:
                                                        item.assocLeads.length > 1 ? "#333" : "#fff",
                                                }}
                                            >
                                                {item.assocLeads.length}
                                            </span>
                                            <div className="popover-badge-outer">
                                                <div className="popover-badge-box">
                                                    <div className="d-flex align-items-center justify-content-between pp-header">
                                                        <div className="xs-title pp-title text-uppercase">
                                                            Previous Appraisals
                                                        </div>
                                                        <div>
                                                            <button
                                                                className="pp-close-btn"
                                                                type="button"
                                                                onClick={() => setHoveredIndex(null)}
                                                            >
                                                                <img src={getImages("close-shape.png")} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="pp-table">
                                                        <table className="w-100">
                                                            <tbody>
                                                                {item.assocLeads.map((lead, i) => (
                                                                    <tr key={i}>
                                                                        <td>{lead?.vehicle_name?.slice(0, 35)}</td>
                                                                        <td>
                                                                            {lead.expiration_str
                                                                                ? lead.expiration_str
                                                                                : ""}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            <button
                                                                                onClick={() =>
                                                                                    window.open(
                                                                                        `/store?lead_id=${lead?.id}`,
                                                                                        "_blank"
                                                                                    )
                                                                                }
                                                                                className="blue-btn sm-btn text-uppercase"
                                                                            >
                                                                                Open
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                ) : (
                                    <td></td>
                                )}

                                <td
                                    className="cursor-pointer text-dblue"
                                    onClick={() => leadAction(item)}
                                >
                                    {item.vehicle_name}
                                </td>
                                <td
                                    className="cursor-pointer"
                                    onClick={() => leadAction(item)}
                                >
                                    {item.location}
                                </td>
                                <td
                                    className="cursor-pointer text-center"
                                    onClick={() => leadAction(item)}
                                >
                                    {item.appraisal_date_str}
                                </td>
                                <td
                                    className={`cursor-pointer text-center text-dblue 
                                    ${item.days_to_expire > 2 && item.days_to_expire <= 4 ? "text-yellow" : ""} 
                                    ${item.days_to_expire > 0 && item.days_to_expire <= 2 ? "text-orange" : ""} 
                                    ${item.days_to_expire <= 0 ? "text-red" : ""}`}
                                    onClick={() => leadAction(item)}
                                >
                                    {item.appraisal_date_str} <br />
                                    {item.expiration_str}
                                </td>
                                <td
                                    className="cursor-pointer text-center"
                                    onClick={() => leadAction(item)}
                                >
                                    <img src={getImages("search.png")} alt="Search" />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* 👇 Pagination section after map */}
            {pageCount > 1 && (
                <div className="pagination-wrapper mt-3 mb-3">
                    <ReactPaginate
                        previousLabel={"‹ Prev"}
                        nextLabel={"Next ›"}
                        breakLabel={"..."}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={3}
                        onPageChange={handlePageClick}
                        containerClassName={"search-pagination"}
                        activeClassName={"active"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        previousClassName={"page-item"}
                        previousLinkClassName={"page-link"}
                        nextClassName={"page-item"}
                        nextLinkClassName={"page-link"}
                        breakClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                    />
                </div>
            )}
        </>
    );
};

export default AppraisalCustomerTable;
